module.exports = __webpack_public_path__ + "img/caitlyn.dc54b171.png";